// fix-growave-wishlist.js
document.addEventListener('DOMContentLoaded', function () {
  function fixWishlistButtons() {
    const buttons = document.querySelectorAll('.gw-toggle-wishlist-product-card-button:not([data-gw-fixed])');
    
    if (buttons.length === 0) {
      setTimeout(fixWishlistButtons, 1000);
      return;
    }

    buttons.forEach(btn => {
      // 只改 type，不阻止任何事件
      btn.type = 'button';
      
      // 标记已处理
      btn.dataset.gwFixed = 'true';
    });
    
    console.log('Growave wishlist buttons fixed (type=button):', buttons.length);
  }

  fixWishlistButtons();
});